export enum Role {
  HeadOfOperations = 'head_of_operations',
  LeadProductionManager = 'lead_production_manager',
  ProductionManager = 'production_manager',
  Supervisor = 'supervisor',
  ITDefault = 'it_default',
  SalesAssistant = 'sales_assistant',
  LeadSalesAssistant = 'sales_lead_sales_assistant',
  SalesKamBdm = 'sales_kam_bdm',
  SalesEngineer = 'sales_engineer',
  HeadOfSales = 'head_of_sales',
}

export enum FinanceRole {
  HeadOfFinance = 'head_of_finance',
  FinAccountantPayables = 'fin_accountant_payables',
  FinAccountantReceivables = 'fin_accountant_receivables',
  FinDataAnalyst = 'fin_data_analyst',
  FinExternalAuditor = 'fin_external_auditor',
}

export const FINANCE_ROLES_IDS = [1, 26, 27, 31, 32];

export const SUPPORT_ROLE_ID = 33;
